"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KatjasHourglassAbilityHandler = exports.KatjasHourglassActorAbilityFactory = exports.KatjasHourglassAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class KatjasHourglassAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.KatjasHourglass;
        this.__typeName = "KatjasHourglass";
    }
}
exports.KatjasHourglassAbilityArgs = KatjasHourglassAbilityArgs;
let KatjasHourglassActorAbilityFactory = class KatjasHourglassActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("KatjasHourglass", "Self", 4);
    }
};
KatjasHourglassActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("KatjasHourglass")
], KatjasHourglassActorAbilityFactory);
exports.KatjasHourglassActorAbilityFactory = KatjasHourglassActorAbilityFactory;
let KatjasHourglassAbilityHandler = class KatjasHourglassAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        sequence = sequence.pushSequence("sequential");
        container.applyBuff({
            sequence,
            creatorId: ability.invokerId,
            targetId: ability.invokerId,
            duration: Duration_1.Duration.EndOfTurn,
            effect: new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.ExtraActions, 2)
        });
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(ability.invokerId, "feet"), "BlueLightPillar"));
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .filter(allyId => allyId !== ability.invokerId)
                    .forEach(allyId => {
                    container.resetAllAbilityCooldowns(sequence, allyId);
                    sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(allyId, "feet"), "BeamFromTheHeavens"));
                });
            }
        });
    }
};
KatjasHourglassAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.KatjasHourglass)
], KatjasHourglassAbilityHandler);
exports.KatjasHourglassAbilityHandler = KatjasHourglassAbilityHandler;
